import { GetServerSidePropsContext } from 'next';

import { getCMSData } from '~/lib/api';
import { IPages, IRedirect } from '~/lib/data-contract';

type ContextType = GetServerSidePropsContext;

export async function pageResolver({ req, resolvedUrl }: ContextType) {
	return await getCMSData<IPages | IRedirect>(`api/content/page`, { url: resolvedUrl }, req);
}
